import { render, staticRenderFns } from "./ExtraDependencies.vue?vue&type=template&id=ae75784c&"
import script from "./ExtraDependencies.vue?vue&type=script&lang=js&"
export * from "./ExtraDependencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports